import { useReducer, useEffect, useCallback } from 'react'
import { AuthState } from './AuthContext'
import { authService } from '../infrastructure/services/authService'

interface AuthStateWithLoading extends AuthState {
  loading: boolean
}

function authReducer(state: AuthStateWithLoading, action: Partial<AuthStateWithLoading>): AuthStateWithLoading {
  return { ...state, ...action }
}

export function useAuthStatus() {
  const [state, dispatch] = useReducer(authReducer, {
    authStatus: 'loading',
    loading: true,
  })

  const setAuthState = useCallback((newState: Partial<AuthState>) => {
    dispatch(newState)
  }, [])

  useEffect(() => {
    async function initAuth() {
      dispatch({ loading: true })
      
      try {
        // Check if user has valid session
        const hasValidSession = await authService.validateSession()
        
        if (hasValidSession) {
          dispatch({ authStatus: 'signedIn' })
        } else {
          dispatch({ authStatus: 'signedOut' })
        }
      } catch (e) {
        console.error('Auth init failed:', e)
        dispatch({ authStatus: 'signedOut' })
      } finally {
        dispatch({ loading: false })
      }
    }

    initAuth()
  }, [])

  return { ...state, setAuthState }
}
